import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { confirmAdyenBatch, getAdyenBatches, getAdyenBatchesByBatchNumber } from 'src/api/adyen-batch';
import {
    CONFIRM_ADYEN_BATCH,
    FETCH_ADYEN_BATCHES,
    FETCH_ADYEN_BATCHES_BY_BATCH_NUMBER,
    requestAdyenBatches,
    requestAdyenBatchesByBatchNumber,
    requestAdyenBatchesByBatchNumberFailure,
    requestAdyenBatchesByBatchNumberSuccess,
    requestAdyenBatchesFailure,
    requestAdyenBatchesSuccess,
    requestConfirmAdyenBatch,
    requestConfirmAdyenBatchFailure,
    requestConfirmAdyenBatchSuccess,
} from './actions';

function* fetchAdyenBatchesSaga(action: AnyAction): SagaIterator {
    yield put(requestAdyenBatches());

    const { error, response } = yield call(getAdyenBatches, action.pageable, action.batchNumber, action.confirmedState);

    if (error) {
        yield put(requestAdyenBatchesFailure(error));
    } else {
        yield put(requestAdyenBatchesSuccess(response));
    }
}

export function* generateFetchAdyenBatchesWatcher() {
    yield takeLatest(FETCH_ADYEN_BATCHES, fetchAdyenBatchesSaga);
}

function* fetchAdyenBatchesByBatchNumberSaga(action: AnyAction): SagaIterator {
    yield put(requestAdyenBatchesByBatchNumber());

    const { error, response } = yield call(getAdyenBatchesByBatchNumber, action.batchNumber);

    if (error) {
        yield put(requestAdyenBatchesByBatchNumberFailure(error));
    } else {
        yield put(requestAdyenBatchesByBatchNumberSuccess(response));
    }
}

export function* generateFetchAdyenBatchesByBatchNumberWatcher() {
    yield takeLatest(FETCH_ADYEN_BATCHES_BY_BATCH_NUMBER, fetchAdyenBatchesByBatchNumberSaga);
}

function* confirmAdyenBatchSaga(action: AnyAction): SagaIterator {
    yield put(requestConfirmAdyenBatch());

    const { error, response } = yield call(confirmAdyenBatch, action.batchNumber, action.adyenConfirmationRequest);

    if (error) {
        yield put(requestConfirmAdyenBatchFailure(error));
    } else {
        yield put(requestConfirmAdyenBatchSuccess(response));
    }
}

export function* generateConfirmAdyenBatchWatcher() {
    yield takeLatest(CONFIRM_ADYEN_BATCH, confirmAdyenBatchSaga);
}
